export const BG = {
    light01: "#FEFBFB",
    light02: "#F4EEED",
    mid: "#D2CDCC",
    deep01: "#B0ABAB",
    deep02: "#6C6969"
};

export const FONT = {
    light01: "#F8FAFC",
    light02: "#E7ECF3",
    mid: "#A5B7D1",
    deep01: "#687C97",
    default: "#32373F"
};

// HSL 표기 시 Lightness 값 : 95(1) / 66(0.69) / 50(0.52)
export const MAIN_BLUE = {
    light: "#E6EFFF",
    mid: "#5592FC",
    deep: "#045EFB"
};

// HSL 표기 시 Lightness 값 : 95(1) / 66(0.69) / 50(0.52)
export const MAIN_YELLOW = {
    light: "#FFF7E6",
    mid: "#FCC756",
    deep: "#FBAC04"
};